export const LOGIN = "auth/LOGIN";
export const FORGOT_PASSWORD = "auth/FORGOT_PASSWORD";
export const RESET_PASSWORD = "auth/RESET_PASSWORD";
export const VERIFY_TOKEN = "auth/VERIFY_TOKEN";
export const SIGN_UP = "auth/SIGNUP";
export const GET_LOGGED_IN_USER = "user/GET_LOGGED_IN_USER";
export const GET_GLOBAL_TIME_PERIOD_FROM_STORAGE = "timePeriod/GET_GLOBAL_TIME_PERIOD_FROM_STORAGE";
export const GET_TIME_PERIODS_FROM_STORAGE = "timePeriod/GET_TIME_PERIODS_FROM_STORAGE";
